<template>
  <div class="coupon-list-popup">
    <div class="coupon-list-popup-shade"></div>
    <div class="coupon-list-popup-content">
      <p class="coupon-list-popup-title">{{ languages.couponSelect }}</p>
      <div class="coupon-list-popup-content-scroll">
        <div class="coupon-list-popup-type">
          <span class="coupon-list-popup-name">
            {{ languages.couponCanUse
            }}<span class="coupon-list-popup-type-total"
              >({{ enableCouponList.length }})</span
            >
          </span>
          <span class="coupon-list-popup-type-tip">{{
            languages.couponUseTip
          }}</span>
        </div>
        <template v-if="enableCouponList.length">
          <coupon-item
            v-for="item in enableCouponList"
            :key="item.COUPON_ID"
            :info="item"
            :active="item.COUPON_ID == activeCouponId"
            :languages="languages"
            :showItemUseBtn="showItemUseBtn"
            @chooseCoupon="chooseCoupon"
            @closePopup="hidePopup"
          >
            {{ item.COUPON_ID }}
          </coupon-item>
        </template>
        <template v-else>
          <coupon-item :isEmpty="true" :languages="languages"></coupon-item>
        </template>
        <div class="coupon-list-popup-type">
          <span class="coupon-list-popup-name">
            {{ languages.couponCanNotUse
            }}<span class="coupon-list-popup-type-total"
              >({{ invalidCouponTotal }})</span
            >
          </span>
        </div>
        <template v-if="invalidCouponTotal > 0">
          <coupon-item
            v-for="item in disableCouponList"
            :key="item.COUPON_ID"
            :info="item"
            :invalid="true"
            :languages="languages"
          ></coupon-item>
          <coupon-item
            v-for="item in expireCouponList"
            :key="item.COUPON_ID"
            :info="item"
            :invalid="true"
            :languages="languages"
          ></coupon-item>
        </template>
        <template v-else>
          <coupon-item
            :isEmpty="true"
            :invalid="true"
            :languages="languages"
          ></coupon-item>
        </template>
      </div>
      <div
        v-if="popupType == 'paytype'"
        class="coupon-list-popup-use j-click-coupon-use"
        @click="updateActiveCouponId"
        :pointValue="activeCouponId"
      >
        {{ languages.couponSureUse }}
      </div>
      <a
        class="coupon-list-popup-close j-click-coupon-close"
        href="javascript:;"
        @click="hidePopup"
        >x</a
      >
    </div>
  </div>
</template>

<script type="text/javascript">
import CouponItem from './CouponItem.vue';
import { UPDATE_PAYTYPE_ACTIVE_COUPON_ID } from '../../store/store/coupon';
export default {
  name: 'couponListPopup',
  props: [
    'enableCouponList',
    'disableCouponList',
    'expireCouponList',
    'activeId',
    'languages',
    'popupType',
    'showItemUseBtn'
  ],
  data() {
    return {
      activeCouponId: '',
      acticeCouponInfo: ''
    };
  },
  created() {
    if (this.popupType == 'paytype') {
      if (this.activeId) {
        this.activeCouponId = this.activeId;
      } else {
        this.autoSelectFirstCoupon();
      }
    }
  },
  computed: {
    invalidCouponTotal() {
      return this.disableCouponList.length + this.expireCouponList.length;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closeCouponPopup');
    },
    chooseCoupon(couponInfo) {
      this.acticeCouponInfo = couponInfo;
      if (this.popupType == 'game') {
        return;
      }
      if (this.activeCouponId == couponInfo.COUPON_ID) {
        this.activeCouponId = '';
      } else {
        this.activeCouponId = couponInfo.COUPON_ID;
      }
    },
    updateActiveCouponId() {
      if (this.activeCouponId) {
        window.sdkstoreDataLayer.push({
          eventName: 'select_coupon',
          eventReason: 'click_select',
          eventType: 'choose',
          eventValue: {
            coupon_typeid: this.acticeCouponInfo?.COUPON_TYPE || '',
            coupon_type_name: this.acticeCouponInfo?.tagText || '',
            coupon_id: this.acticeCouponInfo?.COUPON_ID || '',
            coupon_start_time: this.acticeCouponInfo?.GET_TIME || '',
            coupon_end_time: this.acticeCouponInfo?.EXPIRY_TIME || '',
            coupon_local_money: this.acticeCouponInfo?.fullReductMoney || '',
            coupon_discount: this.acticeCouponInfo?.DISCOUNT || ''
          }
        });
      } else {
        window.sdkstoreDataLayer.push({
          eventName: 'select_coupon',
          eventReason: 'click_select',
          eventType: 'cancel',
          eventValue: {
            coupon_typeid: '',
            coupon_type_name: '',
            coupon_id: '',
            coupon_start_time: '',
            coupon_end_time: '',
            coupon_local_money: '',
            coupon_discount: ''
          }
        });
      }
      this.$store.commit(UPDATE_PAYTYPE_ACTIVE_COUPON_ID, this.activeCouponId);
      this.hidePopup();
    },
    autoSelectFirstCoupon() {
      if (this.enableCouponList && this.enableCouponList.length) {
        this.activeCouponId = this.enableCouponList[0].COUPON_ID;
      }
    }
  },
  components: {
    CouponItem
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/base.scss';
.coupon-list-popup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 90%;
    background-color: #f3f3f3;
    padding: 49px 30px 150px;
    box-sizing: border-box;
    &-scroll {
      position: relative;
      max-height: 90%;
      overflow-y: scroll;
      // padding-bottom: 100px;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
      }
    }
  }

  &-title {
    color: #414141;
    font-size: 36px;
    text-align: center;
    margin-bottom: 39px;
  }
  &-type {
    display: flex;
    justify-content: space-between;
    margin-bottom: 17px;
    font-size: 30px;
    color: #707070;
    margin-top: 39px;
    &:nth-child(1) {
      margin-top: 0;
    }
    &-tip {
      font-size: 24px;
      color: #62c6c4;
    }
  }
  &-use {
    position: absolute;
    bottom: 66px;
    color: #fff;
    background-color: #de6262;
    font-size: 32px;
    text-align: center;
    line-height: 80px;
    height: 80px;
    width: 690px;
    left: 50%;
    transform: translateX(-50%);
    // margin-top: 58px;
  }
  &-close {
    position: absolute;
    top: 30px;
    right: 31px;
    width: 37px;
    height: 37px;
    font-size: 52px;
    color: #414141;
    cursor: pointer;
  }
}

@media screen and (orientation: landscape) {
  .coupon-list-popup {
    &-content {
      width: 70%;
      padding: 49px 88px 150px;
    }
    &-use {
      bottom: 18px;
    }
  }
}
</style>
